<div class="flex items-center justify-between border-b border-slate-200 bg-slate-50/80 px-6 py-4 backdrop-blur">
  <div class="min-w-0">
    <p class="text-xs font-medium uppercase tracking-wide text-slate-500">Delegate profile</p>
    <h2 class="mt-1 text-base font-semibold text-slate-900 sm:text-lg">
      Edit profile information
    </h2>
  </div>
  <button
    mat-dialog-close
    class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 shadow-sm transition-colors hover:border-slate-300 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-1 focus-visible:ring-offset-slate-50"
  >
    <mat-icon class="text-base">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography bg-slate-50">
  <form
    [formGroup]="signupFieldsForm"
    novalidate
    enctype="multipart/form-data"
    class="mx-auto max-w-5xl space-y-5 py-5"
  >
    <section class="rounded-lg border border-slate-200 bg-white shadow-sm">
      <div class="border-b border-slate-100 bg-slate-50 px-4 py-3">
        <p class="text-sm font-semibold text-slate-900">Profile details</p>
        <p class="text-xs text-slate-500">
          Update the delegate’s personal and contact information. Required fields are validated.
        </p>
      </div>
      <div class="px-4 py-4">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <ng-container *ngFor="let field of all_extra_fields_arr">
            <div *ngIf="field['field_type']==1">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                  [id]="field['field_original_name']"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <textarea
                  matInput
                  [formControlName]="field['field_original_name']"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                  [id]="field['field_original_name']"
                ></textarea>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==3">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select matInput [formControlName]="field['field_original_name']" [compareWith]="compareSelectValues">
                  <mat-option *ngFor="let option of field['drop_down_value']" [value]="option['id']">
                    {{option['option_value']}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==6">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select matInput [formControlName]="field['field_original_name']" [compareWith]="compareSelectValues">
                  <mat-option *ngFor="let option of field['drop_down_value']" [value]="option['id']">
                    {{option['option_value']}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==24">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select matInput [formControlName]="field['field_original_name']" [compareWith]="compareSelectValues">
                  <mat-option *ngFor="let option of field['drop_down_value']" [value]="option['id']">
                    {{option['option_value']}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==8">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'number'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==9">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                  [id]="field['field_original_name']"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==10">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==11">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==16">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select matInput [formControlName]="field['field_original_name']" [compareWith]="compareSelectValues">
                  <mat-option *ngFor="let option of field['drop_down_value']" [value]="option['id']">
                    {{option['option_value']}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==17">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  max="3"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="2"
                  oninput="this.value = this.value.replace(/[^0-9-]|^ /g,'')"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==18">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select
                  matInput
                  [formControlName]="field['field_original_name']"
                  [compareWith]="compareSelectValues"
                  (selectionChange)="changeCountry($event.value)"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      #countrySearch
                      [hideClearSearchButton]="true"
                      placeholderLabel="Search..."
                      noEntriesFoundLabel="No data found!"
                      (input)="countrySearchOption(countrySearch.value)"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let country of countryArr" [value]="country['id']">
                    {{country['name']}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==21">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select
                  matInput
                  [formControlName]="field['field_original_name']"
                  [compareWith]="compareSelectValues"
                  (selectionChange)="changeState($event.value)"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      #stateSearch
                      [hideClearSearchButton]="true"
                      placeholderLabel="Search..."
                      noEntriesFoundLabel="No data found!"
                      (input)="stateSearchOption(stateSearch.value)"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let state of stateArr" [value]="state['id']">
                    {{state['name']}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==20">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <mat-select matInput [formControlName]="field['field_original_name']" [compareWith]="compareSelectValues">
                  <mat-option>
                    <ngx-mat-select-search
                      #citySearch
                      [hideClearSearchButton]="true"
                      placeholderLabel="Search..."
                      noEntriesFoundLabel="No data found!"
                      (input)="citySearchOption(citySearch.value)"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let city of cityArr" [value]="city['id']">
                    {{city['name']}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==14">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                  readonly
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==15">
              <div class="w-full">
                <app-phone-input
                  [formControlName]="field['field_original_name']"
                  [label]="field['title'] || 'Mobile'"
                  placeholder="Enter Number"
                  [defaultCountry]="'IN'"
                  [preferredCountries]="['IN','US','GB']"
                  [enablePlaceholder]="true"
                  [enableSearch]="true"
                ></app-phone-input>
              </div>
            </div>
            <div *ngIf="field['field_type']==19">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                  [id]="field['field_original_name']"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==22">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                />
                <mat-error *ngIf="myError(field['field_original_name'], 'required')">
                  This field required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="field['field_type']==23">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{field['title']}}</mat-label>
                <input
                  matInput
                  [formControlName]="field['field_original_name']"
                  [type]="'text'"
                  autocomplete="off"
                  [placeholder]="field['title']"
                  maxlength="255"
                  [id]="field['field_original_name']"
                />
              </mat-form-field>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="border-t border-slate-200 bg-slate-50 px-6 py-3">
  <button
    matButton="outlined"
    [disabled]="isProfileUpdating"
    (click)="updateExtraField()"
    class="mr-2 inline-flex items-center rounded-md border border-indigo-600 bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-indigo-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400"
  >
    {{ isProfileUpdating ? 'Updating...' : 'Update' }}
  </button>
  <button
    [mat-dialog-close]="true"
    matButton="outlined"
    type="button"
    class="inline-flex items-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-1"
  >
    Cancel
  </button>
</mat-dialog-actions>
